
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Variable } from "@/types/variables";

interface VariableCardProps {
  variable: Variable;
  onEdit: (variable: Variable) => void;
  onDelete: (id: string) => void;
}

const VariableCard: React.FC<VariableCardProps> = ({ variable, onEdit, onDelete }) => {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="text-lg">{variable.name}</CardTitle>
        <CardDescription>{variable.category}</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-2">{variable.description}</p>
        <div className="bg-muted p-2 rounded-md mt-2">
          <p className="font-mono text-sm break-all">{variable.syntax}</p>
        </div>
        <div className="mt-4">
          <p className="text-sm font-semibold">Value:</p>
          <p className="text-sm truncate">{variable.value}</p>
        </div>
      </CardContent>
      <CardFooter className="flex justify-between">
        <Button variant="outline" size="sm" onClick={() => onEdit(variable)}>Edit</Button>
        <Button variant="destructive" size="sm" onClick={() => onDelete(variable.id)}>Delete</Button>
      </CardFooter>
    </Card>
  );
};

export default VariableCard;
